import ajax from '../js/common/ajax';

export default {
  getBusinessTypes() {
    return ajax.get('/invoice-business-types');
  },

  getBusinessTypesByType(invoiceType) {
    return ajax.get(`/invoice-business-types/by-type/${invoiceType}`);
  },

  getBusinessType(id) {
    return ajax.get(`/invoice-business-types/${id}`);
  },

  createBusinessType(data) {
    return ajax.post('/invoice-business-types', data);
  },

  updateBusinessType(id, data) {
    return ajax.post(`/invoice-business-types/${id}`, data, {
      headers: { 'X-HTTP-Method-Override': 'PUT' }
    });
  },

  deleteBusinessType(id) {
    return ajax.post(`/invoice-business-types/${id}`, {}, {
      headers: { 'X-HTTP-Method-Override': 'DELETE' }
    });
  }
};
